import React from "react";

const PILL = {
  signed: "bg-emerald-500 text-white", awaiting: "bg-orange-400 text-white", opened: "bg-sky-500 text-white",
  missing: "bg-rose-500 text-white", expired: "bg-rose-500 text-white", superseded: "bg-slate-300 text-slate-700", draft: "bg-slate-300 text-slate-700",
};
export const StatusPill = ({ status = "draft", children, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center justify-center min-w-[78px] px-2.5 py-1 rounded-md text-[11px] font-semibold whitespace-nowrap ${PILL[status] || PILL.draft}`}>{children || status[0].toUpperCase() + status.slice(1)}</span>
);

const COLORS = ["#6366f1", "#10b981", "#fb923c", "#0ea5e9", "#f43f5e", "#8b5cf6", "#14b8a6", "#f59e0b"];
export const initials = (n) => (n || "?").replace("TEST_", "").split(/[\s-]+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
export const Avatar = ({ name, size = 32 }) => {
  const c = COLORS[[...(name || "")].reduce((a, ch) => a + ch.charCodeAt(0), 0) % COLORS.length];
  return <span data-testid="avatar" className="text-white rounded-full grid place-items-center font-bold shrink-0" style={{ width: size, height: size, fontSize: size * 0.38, background: c }}>{initials(name)}</span>;
};

export const Skeleton = ({ rows = 4 }) => (
  <div className="space-y-2" data-testid="skeleton">{Array.from({ length: rows }).map((_, i) => <div key={i} className="h-12 rounded-xl bg-slate-200/70 animate-pulse" />)}</div>
);

export const EmptyState = ({ icon: Icon, title, text, action, testid }) => (
  <div data-testid={testid} className="text-center py-10 px-4">
    {Icon && <div className="w-12 h-12 rounded-2xl bg-indigo-50 text-indigo-500 grid place-items-center mx-auto mb-3"><Icon size={22} /></div>}
    <div className="font-heading font-bold text-slate-800">{title}</div>
    {text && <div className="text-sm text-slate-500 mt-1">{text}</div>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const relTime = (iso) => {
  if (!iso) return "—";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  const m = s / 60, h = m / 60, d = h / 24;
  if (m < 60) return `${Math.floor(m)} min ago`;
  if (h < 24) return `${Math.floor(h)} h ago`;
  if (d < 30) return `${Math.floor(d)} day${Math.floor(d) === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString("en-AU");
};

export const ConfidenceBar = ({ value = 0 }) => (
  <div className="flex items-center gap-2" data-testid="confidence-bar">
    <div className="flex-1 h-2 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full rounded-full ${value >= 80 ? "bg-emerald-500" : value >= 60 ? "bg-orange-400" : "bg-rose-500"}`} style={{ width: `${Math.min(100, value)}%` }} /></div>
    <span className="text-xs font-bold font-num text-slate-600 w-9 text-right">{value}%</span>
  </div>
);

export const Progress = ({ value = 0 }) => (
  <div className="flex items-center gap-2 min-w-[110px]"><div className="flex-1 h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full ${value >= 80 ? "bg-emerald-500" : value >= 50 ? "bg-orange-400" : "bg-rose-500"}`} style={{ width: `${value}%` }} /></div><span className="text-[11px] font-num text-slate-500 w-8">{value}%</span></div>
);

export const COMPLETE_FIELDS = ["mobile", "email", "dob", "address", "visa_type", "visa_expiry", "start_date", "emergency_contact", "kronos"];
export const completeness = (e) => Math.round((100 * (COMPLETE_FIELDS.filter((k) => String(e[k] || "").trim()).length + (e.contract_signed ? 1 : 0) + (e.induction_completed ? 1 : 0))) / (COMPLETE_FIELDS.length + 2));

export const visaStatus = (e) => {
  if (!e.visa_expiry) return ["missing", "Missing"];
  const days = (new Date(e.visa_expiry) - Date.now()) / 864e5;
  if (days < 0) return ["expired", "Expired"];
  if (days < 30) return ["awaiting", `${Math.ceil(days)}d left`];
  return ["signed", "Valid"];
};
export const contractStatus = (e) => (e.contract_signed ? ["signed", "Signed"] : ["awaiting", "Awaiting"]);
export const inductionStatus = (e) => (e.induction_completed ? ["signed", "Done"] : ["awaiting", "Awaiting"]);

export function Celebrate({ show }) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[100] pointer-events-none grid place-items-center" data-testid="celebrate">
      <div className="relative">
        {Array.from({ length: 14 }).map((_, i) => (
          <span key={i} className="absolute w-2.5 h-2.5 rounded-sm hr-confetti" style={{ background: ["#22c55e", "#6366f1", "#f97316", "#0ea5e9"][i % 4], transform: `rotate(${i * 26}deg) translateY(-10px)`, animationDelay: `${i * 15}ms` }} />
        ))}
        <div className="w-20 h-20 rounded-full bg-emerald-500 text-white grid place-items-center text-4xl shadow-2xl hr-pop">✓</div>
      </div>
    </div>
  );
}
